var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { Children } from 'react';
var SplitPageWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  height: 100%;\n"], ["\n  display: flex;\n  height: 100%;\n"])));
var RightColumn = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding-left: 4rem;\n  width: 50%;\n"], ["\n  padding-left: 4rem;\n  width: 50%;\n"])));
var LeftColumn = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding-right: 4rem;\n  width: 50%;\n"], ["\n  padding-right: 4rem;\n  width: 50%;\n"])));
var Split = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  border-left: 1px solid #ced4da;\n"], ["\n  border-left: 1px solid #ced4da;\n"])));
var SplitPage = function (_a) {
    var children = _a.children;
    return _jsx(SplitPageWrapper, { children: Children.map(children, function (child, index) { return (_jsxs(_Fragment, { children: [index === 0
                    ? _jsx(LeftColumn, { children: child })
                    : _jsx(RightColumn, { children: child }), index === 0 && _jsx(Split, {})] })); }) });
};
export default SplitPage;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
